import { render, staticRenderFns } from "./ad-keywrod-log.vue?vue&type=template&id=53e80841&scoped=true&"
import script from "./ad-keywrod-log.vue?vue&type=script&lang=js&"
export * from "./ad-keywrod-log.vue?vue&type=script&lang=js&"
import style0 from "./ad-keywrod-log.vue?vue&type=style&index=0&id=53e80841&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e80841",
  null
  
)

export default component.exports